import { render, staticRenderFns } from "./NewMvProject.vue?vue&type=template&id=5a74e178&scoped=true&"
import script from "./NewMvProject.vue?vue&type=script&lang=js&"
export * from "./NewMvProject.vue?vue&type=script&lang=js&"
import style0 from "./NewMvProject.vue?vue&type=style&index=0&id=5a74e178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a74e178",
  null
  
)

export default component.exports